import { TENANT_PLATFORM } from '@hiver/bifrost-js';
import { ReactComponent as GmailIcon }  from "../../images/GmailIcon.svg";
import { ReactComponent as OutlookIcon } from "../../images/OutlookIcon.svg";
import { ReactComponent as OtherLoginIcon } from "../../images/OtherLoginIcon.svg";

export const EMAIL_PLACEHOLDER = 'Enter your Hiver email';
export const PASSWORD_PLACEHOLDER = 'Enter your password';
export const LOG_IN_DESCRIPTION = 'Log in to access your Help center';
export const LOG_IN = 'Log In';
export const CONTINUE = 'Continue';
export const OTP_SCREEN_BUTTON_LABEL = 'Login';
export const OTP_LABEL = 'Enter verification code';
export const WELCOME = 'Welcome!';
export const DIFF_EMAIL_ERROR = 'Please login using the same Google account';
export const NO_ACCESS_ERROR = 'You don’t have access to this section, please contact your administrator';
export const DEFAULT_LOGO = 'default';
export const LOGO_IMG = 'https://app.hiverkb.com/{{LOGO}}';
export const selectEmailProviderText = 'Select your email provider';
export const selectProductText = 'Select the product you want to access';
export const gmail = 'Gmail';
export const outlook = 'Outlook';
export const other = 'Other';
export const emailLabel = 'Enter your email address';
export const passwordLabel = 'Enter your password';
export const EMAIL_PROVIDER_OTHER = 'other';
export const hiverOmni = 'Hiver Omni';
export const hig = 'HIG (Hiver in Gmail)';

export const PRODUCT_TYPE = {
    OMNI: 'omni',
    HIG: 'hig'
};

export const AUTH_PROVIDER = {
    GOOGLE: 'google',
    MICROSOFT: 'microsoft'
};

export const EMAIL_SELECTOR_PROVIDERS = [
    {
        NAME: gmail,
        TENANT_ID: TENANT_PLATFORM.GMAIL,
        ICON: GmailIcon,
        IMG_ALT: gmail
    },
    {
        NAME: outlook,
        TENANT_ID: TENANT_PLATFORM.HIVERWEB,
        ICON: OutlookIcon,
        IMG_ALT: outlook
    },
    {
        NAME: other,
        TENANT_ID: EMAIL_PROVIDER_OTHER,
        ICON: OtherLoginIcon,
        IMG_ALT: other
    }
];

export const PRODUCT_OPTIONS = [
    {
        ID: PRODUCT_TYPE.OMNI,
        NAME: hiverOmni,
        VALUE: PRODUCT_TYPE.OMNI
    },
    {
        ID: PRODUCT_TYPE.HIG,
        NAME: hig,
        VALUE: PRODUCT_TYPE.HIG
    }
];

// ── New wizard login constants ──
export const WIZARD_STEPS = {
    EMAIL: 'email',
    PRODUCT: 'product',
    SIGN_IN: 'signIn',
};

export const welcomeTitle = 'Welcome!';
export const welcomeSubtitle = 'Log in to access your Help center';
export const workEmailLabel = 'Work email';
export const emailInputPlaceholder = 'e.g. name@acme.com';
export const continueButtonText = 'Continue';
export const chooseProductTitle = 'Choose a product';
export const chooseProductSubtitle = 'Your account has access to both products.';
export const omniProductDesc = 'Multi-channel customer support platform';
export const higProductDesc = 'Hiver inside Gmail — inbox collaboration';
export const signIntoOmniTitle = 'Sign into Omni';
export const googleRedirectSubtitle = "Your account uses Google sign-in. We'll redirect you to Google to authenticate.";
export const signInWithGoogleText = 'Sign in with Google';
export const signInWithMicrosoftText = 'Sign in with Microsoft';
export const orDividerText = 'OR';
export const enterPasswordLabel = 'Enter Password';
export const enterPasswordPlaceholder = 'Enter Password';
export const logInButtonText = 'Log In';

export const EXTERNAL_ACCESS_COPY = {
    emailTitle: 'Confirm your email address',
    emailSubtitle:
        "This Help Center is private. Enter your email address and we'll send you a 6-digit code.",
    emailPlaceholder: 'e.g. name@acme.com',
    otpTitle: 'Check your email',
    otpSubtitle: 'We sent a 6-digit code. It expires in 10 minutes.',
    changeEmail: 'Change',
    resendPrompt: 'Did not get it?',
    resend: 'Resend',
    resendCountdown: 'Resend in {{seconds}}s',
    invalidCode:
        'That code is incorrect or has expired. Try again or ask for a new one.',
    throttled: 'Too many attempts. Please try again later.',
    unavailable: 'Something went wrong. Please try again later.',
    restrictedTitle: "You don't have access to this Help Center",
    restrictedBody:
        'Ask the person who manages this Help Center to give your email address access.',
    tryAnotherEmail: 'Try a different email',
};

export const RESEND_COOLDOWN_SECONDS = 60;

export const EXTERNAL_ACTION = {
    OTP_SENT: 'otp_sent',
    HIVER_LOGIN: 'hiver_login',
};

export const EXTERNAL_ROUTE = {
    OTP_SENT: 'otpSent',
    HIVER_LOGIN: 'hiverLogin',
    // the KB has external access switched off; carry on with the normal
    // Hiver sign-in instead of surfacing anything to the viewer
    NOT_ENABLED: 'notEnabled',
    REJECTED: 'rejected',
    UNAVAILABLE: 'unavailable',
};
